import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConsentRequest = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			stroke: "url(#consent-request_svg__paint0_linear_4039_4373)",
			d: "m95.92 116.92 30.38-15.98a6.06 6.06 0 0 0 2.55-8.14l-15.98-30.38a6.04 6.04 0 0 0-8.14-2.54l-30.4 15.98A6.03 6.03 0 0 0 71.79 84l15.98 30.38a6.04 6.04 0 0 0 8.15 2.53ZM87.5 86.08a2.38 2.38 0 1 0-4.74-.5 2.38 2.38 0 0 0 4.74.5Zm21.42-12.76a2.38 2.38 0 1 1-4.2 2.21 2.38 2.38 0 0 1 4.2-2.2ZM94.35 86.16c3.12-.66 5.99-2.18 8.28-4.4 3.36 5.74-5.2 9.96-8.28 4.4Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft, #A4BCEB)",
			d: "M139.98 166.53a2.22 2.22 0 0 1-3.8 1.57 2.23 2.23 0 1 1 3.8-1.57"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft, #A4BCEB)",
			d: "M163.48 58.77a1.02 1.02 0 0 1-1.2 1 1 1 0 0 1-.8-.79 1.01 1.01 0 1 1 2-.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint1_linear_4039_4373)",
			d: "M55.7 92.59a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint2_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M5.47 76.8h2.67a2.5 2.5 0 0 0 2.51-2.51v-2.67"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint3_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M15.85 76.8H13.2a2.5 2.5 0 0 0-2.52 2.52v2.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint4_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M15.85 76.8H13.2a2.5 2.5 0 0 1-2.52-2.51v-2.67"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint5_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M10.67 79.34a2.75 2.75 0 0 0-2.5-2.52H5.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft, #A4BCEB)",
			stroke: "url(#consent-request_svg__paint6_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M189.65 133.93a2.45 2.45 0 0 0 2.91 2.4 2.44 2.44 0 1 0-2.91-2.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint7_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M115.93 6.3v13.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint8_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M122.69 13.05h-13.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint9_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M34.59 135.37v19.08l-20.14 39.24 41.16-17.56H162.5a8.5 8.5 0 0 0 8.49-8.49V72.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint10_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M143.8 39.6H43.06a8.5 8.5 0 0 0-8.49 8.5v73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint11_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M112.86 62.42a6.03 6.03 0 0 0-8.15-2.54L74.33 75.86A6.03 6.03 0 0 0 71.8 84l15.97 30.38a6.03 6.03 0 0 0 8.15 2.53l30.38-15.98a6.04 6.04 0 0 0 2.53-8.14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint12_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M150.06 176.11V132a6.84 6.84 0 0 0-6.84-6.85H81.45a6.84 6.84 0 0 0-6.84 6.85v44.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M129.32 176.11v-28.49a3.1 3.1 0 0 0-3.08-3.08H98.45a3.1 3.1 0 0 0-3.08 3.08v28.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint13_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M129.32 176.11v-28.49a3.1 3.1 0 0 0-3.08-3.08H98.45a3.1 3.1 0 0 0-3.08 3.08v28.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint14_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m104.61 125.14-1.42-11.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint15_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m117.75 105.43 2.3 19.71"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint16_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m39.9 124.8 24.43 51.33"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint17_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m74.61 151.76-15.39-32.33a3.2 3.2 0 0 0-3.36-1.75l-28.51 4.57a2.3 2.3 0 0 0-1.55.88 2.3 2.3 0 0 0 .5 3.23 2.3 2.3 0 0 0 1.74.37l15.24-2.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint18_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m47.9 118.94-3.39-1.38a2.3 2.3 0 0 1-1.41-2.1 2.28 2.28 0 0 1 3.14-2.11l11.38 4.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint19_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m37.2 125.24-.74-4.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint20_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m31.43 126.16-.72-4.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint21_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m35.36 125.54-5.63 3.18a2.27 2.27 0 0 0 2.25 3.95l9.19-5.24"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint22_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m39.52 128.36-1.87-3.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint23_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m34.4 131.27-2.21-3.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint24_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M32.64 132.29a2.28 2.28 0 0 0 3.8 2.36l5.37-5.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint25_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M38.35 132.55 36 130.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint26_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m49.88 114.84-1.68 4.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint27_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m46.93 139.6 17.85-8.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint28_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m50.26 146.6 17.85-8.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint29_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m53.59 153.58 17.84-8.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint30_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m56.92 160.57 17.7-8.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint31_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m60.24 167.55 14.37-6.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint32_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m63.57 174.54 11.04-5.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint33_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m89.53 67.86-4.98-9.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint34_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M85.9 54.14a3.18 3.18 0 1 1-5.64 2.96 3.18 3.18 0 0 1 5.64-2.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint35_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m104.35 122.9 15.14-2.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint36_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m103.82 117.85 15.1-2.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint37_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m104.08 112.61 14.26-2.23"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint38_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M87.33 176.11v-25.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft, #A4BCEB)",
			stroke: "url(#consent-request_svg__paint39_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M89.56 148.11a2.23 2.23 0 1 1-4.46 0 2.23 2.23 0 0 1 4.46 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint40_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M137.75 176.11v-7.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint41_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M139.98 166.53a2.22 2.22 0 0 1-2.66 2.19 2.24 2.24 0 0 1-1.63-3.05 2.22 2.22 0 0 1 4.3.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint42_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M137.75 164.3v-24.34a3.57 3.57 0 0 0-3.57-3.57H90.91a3.57 3.57 0 0 0-3.58 3.58v5.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint43_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m77.73 58.43-4.18 2.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint44_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m81.28 61.4-1.4 4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint45_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m80.24 50.2-2.4-4.55"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint46_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m77.26 53.8-4.94-1.54"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint47_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m88.45 52.8 4.16-2.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint48_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m88.86 57.4 4.5 1.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint49_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m84.9 49.79 1.53-4.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			stroke: "url(#consent-request_svg__paint50_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m182.52 41.36 3.86-9.9-9.95 3.94a25 25 0 0 0-13.68-4.18c-13.05-.14-23.73 9.42-23.84 21.33-.12 11.9 10.36 21.66 23.4 21.8 13.04.13 23.73-9.42 23.84-21.33a20 20 0 0 0-3.63-11.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint51_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M162.39 54.48c0-1.29.47-2.22 2.04-4.37 1.57-2.16 1.74-3.06 1.76-4.16a3.55 3.55 0 1 0-7.06.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint52_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.48 58.77a1.02 1.02 0 0 1-1.2 1 1 1 0 0 1-.8-.79 1.01 1.01 0 1 1 2-.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-request_svg__paint53_linear_4039_4373)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M54.4 69.62v16.16"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint0_linear_4039_4373",
				x1: 100.316,
				x2: 98.915,
				y1: 108.923,
				y2: 69.802,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint1_linear_4039_4373",
				x1: 54.401,
				x2: 54.339,
				y1: 93.506,
				y2: 91.758,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint2_linear_4039_4373",
				x1: 8.065,
				x2: 7.941,
				y1: 76.033,
				y2: 72.564,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint3_linear_4039_4373",
				x1: 13.264,
				x2: 13.14,
				y1: 81.213,
				y2: 77.744,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint4_linear_4039_4373",
				x1: 13.264,
				x2: 13.14,
				y1: 76.033,
				y2: 72.564,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint5_linear_4039_4373",
				x1: 8.084,
				x2: 8.055,
				y1: 78.963,
				y2: 77.277,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint6_linear_4039_4373",
				x1: 192.088,
				x2: 191.971,
				y1: 135.643,
				y2: 132.377,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint7_linear_4039_4373",
				x1: 116.427,
				x2: 112.88,
				y1: 17.797,
				y2: 10.461,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint8_linear_4039_4373",
				x1: 115.937,
				x2: 115.935,
				y1: 13.898,
				y2: 13.228,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint9_linear_4039_4373",
				x1: 92.722,
				x2: 90.486,
				y1: 175.731,
				y2: 94.821,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint10_linear_4039_4373",
				x1: 89.186,
				x2: 87.727,
				y1: 108.974,
				y2: 54.374,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint11_linear_4039_4373",
				x1: 100.314,
				x2: 98.913,
				y1: 108.923,
				y2: 69.802,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint12_linear_4039_4373",
				x1: 112.336,
				x2: 111.509,
				y1: 168.531,
				y2: 134.377,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint13_linear_4039_4373",
				x1: 112.343,
				x2: 111.639,
				y1: 171.415,
				y2: 150.268,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint14_linear_4039_4373",
				x1: 103.904,
				x2: 101.688,
				y1: 123.367,
				y2: 116.024,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint15_linear_4039_4373",
				x1: 118.905,
				x2: 115.204,
				y1: 122.211,
				y2: 110.124,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint16_linear_4039_4373",
				x1: 52.114,
				x2: 49.538,
				y1: 168.496,
				y2: 134.276,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint17_linear_4039_4373",
				x1: 49.973,
				x2: 49.406,
				y1: 146.686,
				y2: 123.817,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint18_linear_4039_4373",
				x1: 50.357,
				x2: 50.302,
				y1: 118.085,
				y2: 114.221,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint19_linear_4039_4373",
				x1: 36.829,
				x2: 36.22,
				y1: 124.58,
				y2: 121.745,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint20_linear_4039_4373",
				x1: 31.072,
				x2: 30.443,
				y1: 125.504,
				y2: 122.664,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint21_linear_4039_4373",
				x1: 34.888,
				x2: 34.783,
				y1: 131.848,
				y2: 126.882,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint22_linear_4039_4373",
				x1: 38.587,
				x2: 38.457,
				y1: 127.882,
				y2: 125.748,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint23_linear_4039_4373",
				x1: 33.294,
				x2: 33.127,
				y1: 130.684,
				y2: 128.058,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint24_linear_4039_4373",
				x1: 37.152,
				x2: 37.042,
				y1: 134.4,
				y2: 130.016,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint25_linear_4039_4373",
				x1: 37.169,
				x2: 37.121,
				y1: 132.231,
				y2: 130.775,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint26_linear_4039_4373",
				x1: 49.041,
				x2: 48.81,
				y1: 118.284,
				y2: 115.592,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint27_linear_4039_4373",
				x1: 55.857,
				x2: 55.76,
				y1: 138.344,
				y2: 132.654,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint28_linear_4039_4373",
				x1: 59.184,
				x2: 59.087,
				y1: 145.335,
				y2: 139.633,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint29_linear_4039_4373",
				x1: 62.511,
				x2: 62.414,
				y1: 152.314,
				y2: 146.625,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint30_linear_4039_4373",
				x1: 65.763,
				x2: 65.667,
				y1: 159.317,
				y2: 153.666,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint31_linear_4039_4373",
				x1: 67.427,
				x2: 67.348,
				y1: 166.529,
				y2: 161.942,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint32_linear_4039_4373",
				x1: 69.09,
				x2: 69.03,
				y1: 173.758,
				y2: 170.222,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint33_linear_4039_4373",
				x1: 87.041,
				x2: 86.613,
				y1: 66.458,
				y2: 60.162,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint34_linear_4039_4373",
				x1: 83.078,
				x2: 82.925,
				y1: 57.853,
				y2: 53.587,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint35_linear_4039_4373",
				x1: 111.92,
				x2: 111.911,
				y1: 122.542,
				y2: 120.958,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint36_linear_4039_4373",
				x1: 111.371,
				x2: 111.362,
				y1: 117.495,
				y2: 115.91,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint37_linear_4039_4373",
				x1: 111.211,
				x2: 111.202,
				y1: 112.278,
				y2: 110.782,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint38_linear_4039_4373",
				x1: 87.834,
				x2: 79.223,
				y1: 172.279,
				y2: 162.949,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint39_linear_4039_4373",
				x1: 87.334,
				x2: 87.227,
				y1: 149.68,
				y2: 146.693,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint40_linear_4039_4373",
				x1: 138.253,
				x2: 137.039,
				y1: 175.018,
				y2: 170.407,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint41_linear_4039_4373",
				x1: 137.753,
				x2: 137.646,
				y1: 168.094,
				y2: 165.106,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint42_linear_4039_4373",
				x1: 112.543,
				x2: 112.173,
				y1: 160.146,
				y2: 141.444,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint43_linear_4039_4373",
				x1: 75.641,
				x2: 75.613,
				y1: 60.294,
				y2: 58.825,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint44_linear_4039_4373",
				x1: 80.585,
				x2: 80.242,
				y1: 65.226,
				y2: 62.249,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint45_linear_4039_4373",
				x1: 79.044,
				x2: 78.837,
				y1: 49.526,
				y2: 46.486,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint46_linear_4039_4373",
				x1: 74.79,
				x2: 74.779,
				y1: 53.568,
				y2: 52.542,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint47_linear_4039_4373",
				x1: 90.529,
				x2: 90.501,
				y1: 52.468,
				y2: 50.998,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint48_linear_4039_4373",
				x1: 91.115,
				x2: 91.104,
				y1: 58.598,
				y2: 57.66,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint49_linear_4039_4373",
				x1: 85.66,
				x2: 85.284,
				y1: 49.054,
				y2: 45.789,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint50_linear_4039_4373",
				x1: 162.641,
				x2: 161.701,
				y1: 67.932,
				y2: 39.048,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint51_linear_4039_4373",
				x1: 162.64,
				x2: 162.14,
				y1: 52.666,
				y2: 44.534,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint52_linear_4039_4373",
				x1: 162.469,
				x2: 162.42,
				y1: 59.489,
				y2: 58.134,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-request_svg__paint53_linear_4039_4373",
				x1: 54.901,
				x2: 50.202,
				y1: 83.379,
				y2: 75.262,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			})
		] })
	]
});
export default SvgConsentRequest;
